/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @file Openapi Schema
 * @version v1.15.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2026-05-12T11:04:00.377Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/CampaignType
export const CampaignTypeZod = z.union([z.literal('bet-and-get'), z.literal('settlement'), z.literal('promo-code')]);
export type CampaignTypeType = z.TypeOf<typeof CampaignTypeZod>;


// #/components/schemas/PromoCodeView
export const PromoCodeViewZod = z.object({
    promoCode: z.string(),
    isPaused: z.boolean(),
    numberOfUses: z.number().optional().nullable(),
    useLimit: z.number().optional().nullable(),
});
export type PromoCodeViewType = z.TypeOf<typeof PromoCodeViewZod>;


// #/components/schemas/FrequencyPeriod
export const FrequencyPeriodZod = z.union([z.literal('one-time'), z.literal('daily'), z.literal('weekly'), z.literal('monthly'), z.literal('time-bound')]);
export type FrequencyPeriodType = z.TypeOf<typeof FrequencyPeriodZod>;


// #/components/schemas/BettingPlatform
export const BettingPlatformZod = z.union([z.literal('sports-book'), z.literal('casino')]);
export type BettingPlatformType = z.TypeOf<typeof BettingPlatformZod>;


// #/components/schemas/CriteriaType
export const CriteriaTypeZod = z.union([z.literal('account-created'), z.literal('opted-in'), z.literal('min-stake'), z.literal('max-stake'), z.literal('bet-type'), z.literal('bet-min-odds'), z.literal('bet-result'), z.literal('sport'), z.literal('competition'), z.literal('event'), z.literal('market'), z.literal('selection'), z.literal('target-stake'), z.literal('min-bet-frequency'), z.literal('casino-provider'), z.literal('casino-game'), z.literal('casino-result'), z.literal('min-spins'), z.literal('min-monetary-value')]);
export type CriteriaTypeType = z.TypeOf<typeof CriteriaTypeZod>;


// #/components/schemas/Operation
export const OperationZod = z.union([z.literal('eq'), z.literal('neq'), z.literal('gt'), z.literal('lt'), z.literal('gte'), z.literal('lte'), z.literal('in'), z.literal('nin'), z.literal('bw')]);
export type OperationType = z.TypeOf<typeof OperationZod>;


// #/components/schemas/Criteria
export const CriteriaZod = z.object({
    type: CriteriaTypeZod,
    op: OperationZod,
    value: z.unknown(),
});
export type CriteriaType = z.TypeOf<typeof CriteriaZod>;


// #/components/schemas/DraftActionConditions
export const DraftActionConditionsZod = z.object({
    bettingPlatform: z.union([BettingPlatformZod, z.null()]).optional(),
    criteria: z.array(CriteriaZod).optional().nullable(),
    sequenceDependenceOfCriteria: z.array(z.string()).optional().nullable(),
});
export type DraftActionConditionsType = z.TypeOf<typeof DraftActionConditionsZod>;


// #/components/schemas/BonusType
export const BonusTypeZod = z.union([z.literal('free-spin'), z.literal('free-bet')]);
export type BonusTypeType = z.TypeOf<typeof BonusTypeZod>;


// #/components/schemas/DraftReward
export const DraftRewardZod = z.object({
    rewardType: z.union([BonusTypeZod, z.null()]).optional(),
    rewardName: z.string().optional().nullable(),
    rewardAmount: z.number().optional().nullable(),
    expiryAt: z.string().optional().nullable(),
    relativeExpiryDays: z.number().optional().nullable(),
    usageConditions: z.array(CriteriaZod).optional().nullable(),
    totalBet: z.number().optional().nullable(),
    playthrough: z.number().optional().nullable(),
    playthroughEligibleGames: z.array(z.string()).optional().nullable(),
    installmentCount: z.number().optional().nullable(),
    rewardInterval: z.number().optional().nullable(),
    scheduledReward: z.boolean().optional().nullable(),
    rewardDate: z.string().optional().nullable(),
});
export type DraftRewardType = z.TypeOf<typeof DraftRewardZod>;


// #/components/schemas/PlayerType
export const PlayerTypeZod = z.union([z.literal('all-players'), z.literal('new-players'), z.literal('segmented-customers')]);
export type PlayerTypeType = z.TypeOf<typeof PlayerTypeZod>;


// #/components/schemas/CampaignStatus
export const CampaignStatusZod = z.union([z.literal('draft'), z.literal('ready'), z.literal('active'), z.literal('paused'), z.literal('expired')]);
export type CampaignStatusType = z.TypeOf<typeof CampaignStatusZod>;


// #/components/schemas/TimeLimitTrigger
export const TimeLimitTriggerZod = z.union([z.literal('opt-in'), z.literal('account-creation')]);
export type TimeLimitTriggerType = z.TypeOf<typeof TimeLimitTriggerZod>;


// #/components/schemas/CampaignView
export const CampaignViewZod = z.object({
    universe: z.string(),
    campaignId: z.string(),
    campaignType: z.union([CampaignTypeZod, z.null()]).optional(),
    campaignName: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    promoCodes: z.array(PromoCodeViewZod).optional().nullable(),
    startAt: z.string().optional().nullable(),
    expiryAt: z.string().optional().nullable(),
    frequencyPeriod: z.union([FrequencyPeriodZod, z.null()]).optional(),
    numberOfUses: z.number().optional().nullable(),
    actionConditions: z.union([DraftActionConditionsZod, z.null()]).optional(),
    eligibleUsers: z.array(z.number()).optional().nullable(),
    bonusRewards: z.array(DraftRewardZod).optional().nullable(),
    playerType: z.union([PlayerTypeZod, z.null()]).optional(),
    status: CampaignStatusZod,
    minStakeFactor: z.number().optional().nullable(),
    maxStakeFactor: z.number().optional().nullable(),
    minStakeFactorInPlay: z.number().optional().nullable(),
    maxStakeFactorInPlay: z.number().optional().nullable(),
    withPromoCodes: z.boolean().optional().nullable(),
    optInOnly: z.boolean().optional().nullable(),
    timeLimit: z.number().optional().nullable(),
    timeLimitTrigger: z.union([TimeLimitTriggerZod, z.null()]).optional(),
});
export type CampaignViewType = z.TypeOf<typeof CampaignViewZod>;


// #/components/schemas/HttpError400
export const HttpError400Zod = z.object({
    message: z.string(),
});
export type HttpError400Type = z.TypeOf<typeof HttpError400Zod>;


// #/components/schemas/HttpError401
export const HttpError401Zod = z.object({
    message: z.string(),
});
export type HttpError401Type = z.TypeOf<typeof HttpError401Zod>;


// #/components/schemas/HttpError403
export const HttpError403Zod = z.object({
    message: z.string(),
});
export type HttpError403Type = z.TypeOf<typeof HttpError403Zod>;


// #/components/schemas/HttpError500
export const HttpError500Zod = z.object({
    message: z.string(),
});
export type HttpError500Type = z.TypeOf<typeof HttpError500Zod>;


// #/components/schemas/HttpError503
export const HttpError503Zod = z.object({
    message: z.string(),
});
export type HttpError503Type = z.TypeOf<typeof HttpError503Zod>;


// #/components/schemas/HttpError404
export const HttpError404Zod = z.object({
    message: z.string(),
});
export type HttpError404Type = z.TypeOf<typeof HttpError404Zod>;


// #/components/schemas/HttpError422
export const HttpError422Zod = z.object({
    message: z.string(),
});
export type HttpError422Type = z.TypeOf<typeof HttpError422Zod>;


// #/components/schemas/DraftPromoCode
export const DraftPromoCodeZod = z.object({
    promoCode: z.string().optional().nullable(),
    numberOfUses: z.number().optional().nullable(),
    useLimit: z.number().optional().nullable(),
});
export type DraftPromoCodeType = z.TypeOf<typeof DraftPromoCodeZod>;


// #/components/schemas/StartAtType
export const StartAtTypeZod = z.union([z.literal('custom'), z.literal('once-campaign-activated')]);
export type StartAtTypeType = z.TypeOf<typeof StartAtTypeZod>;


// #/components/schemas/BonusCampaignForm
export const BonusCampaignFormZod = z.object({
    campaignType: z.union([CampaignTypeZod, z.null()]).optional(),
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    promoCodes: z.array(DraftPromoCodeZod).optional().nullable(),
    startAt: z.string().optional().nullable(),
    expiryAt: z.string().optional().nullable(),
    frequencyPeriod: z.union([FrequencyPeriodZod, z.null()]).optional(),
    numberOfUses: z.number().optional().nullable(),
    actionConditions: z.union([DraftActionConditionsZod, z.null()]).optional(),
    eligibleUsers: z.array(z.number()).optional().nullable(),
    bonusRewards: z.array(DraftRewardZod).optional().nullable(),
    playerType: z.union([PlayerTypeZod, z.null()]).optional(),
    status: CampaignStatusZod,
    withPromoCodes: z.boolean().optional().nullable(),
    startAtType: StartAtTypeZod,
    minStakeFactor: z.number().optional().nullable(),
    maxStakeFactor: z.number().optional().nullable(),
    minStakeFactorInPlay: z.number().optional().nullable(),
    maxStakeFactorInPlay: z.number().optional().nullable(),
    optInOnly: z.boolean().optional().nullable(),
    timeLimit: z.number().optional().nullable(),
    timeLimitTrigger: z.union([TimeLimitTriggerZod, z.null()]).optional(),
});
export type BonusCampaignFormType = z.TypeOf<typeof BonusCampaignFormZod>;


// #/components/schemas/CampaignUpdateForm
export const CampaignUpdateFormZod = z.object({
    campaignType: z.union([CampaignTypeZod, z.null()]).optional(),
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    promoCodes: z.array(DraftPromoCodeZod).optional().nullable(),
    startAt: z.string().optional().nullable(),
    expiryAt: z.string().optional().nullable(),
    frequencyPeriod: z.union([FrequencyPeriodZod, z.null()]).optional(),
    numberOfUses: z.number().optional().nullable(),
    actionConditions: z.union([DraftActionConditionsZod, z.null()]).optional(),
    bonusRewards: z.array(DraftRewardZod).optional().nullable(),
    playerType: z.union([PlayerTypeZod, z.null()]).optional(),
    status: CampaignStatusZod,
    withPromoCodes: z.boolean().optional().nullable(),
    minStakeFactor: z.number().optional().nullable(),
    maxStakeFactor: z.number().optional().nullable(),
    minStakeFactorInPlay: z.number().optional().nullable(),
    maxStakeFactorInPlay: z.number().optional().nullable(),
    eligibleUsers: z.array(z.number()).optional().nullable(),
    optInOnly: z.boolean().optional().nullable(),
    timeLimit: z.number().optional().nullable(),
    timeLimitTrigger: z.union([TimeLimitTriggerZod, z.null()]).optional(),
});
export type CampaignUpdateFormType = z.TypeOf<typeof CampaignUpdateFormZod>;


// #/components/schemas/CampaignExtendDateForm
export const CampaignExtendDateFormZod = z.object({
    expiryAt: z.string(),
});
export type CampaignExtendDateFormType = z.TypeOf<typeof CampaignExtendDateFormZod>;


// #/components/schemas/CampaignUpdateStatusForm
export const CampaignUpdateStatusFormZod = z.object({
    status: CampaignStatusZod,
});
export type CampaignUpdateStatusFormType = z.TypeOf<typeof CampaignUpdateStatusFormZod>;


// #/components/schemas/PromoCodeUpdateForm
export const PromoCodeUpdateFormZod = z.object({
    isPaused: z.boolean().optional().nullable(),
    useLimit: z.number().optional().nullable(),
    numberOfUses: z.number().optional().nullable(),
});
export type PromoCodeUpdateFormType = z.TypeOf<typeof PromoCodeUpdateFormZod>;


// #/components/schemas/HttpError409
export const HttpError409Zod = z.object({
    message: z.string(),
});
export type HttpError409Type = z.TypeOf<typeof HttpError409Zod>;


// #/components/schemas/BonusSource
export const BonusSourceZod = z.union([z.literal('automated'), z.literal('manual'), z.literal('migration'), z.literal('casino-provider'), z.literal('xtremepush'), z.literal('optimove')]);
export type BonusSourceType = z.TypeOf<typeof BonusSourceZod>;


// #/components/schemas/BonusDetailsForm
export const BonusDetailsFormZod = z.object({
    campaignId: z.string().optional().nullable(),
    amount: z.number().optional().nullable(),
    amountTime: z.number().optional().nullable(),
    startAt: z.string().optional().nullable(),
    expiryAt: z.string(),
    source: BonusSourceZod,
    platform: BettingPlatformZod,
    usageConditions: z.array(CriteriaZod).optional().nullable(),
    playthrough: z.number().optional().nullable(),
    playthroughEligibleGames: z.array(z.string()).optional().nullable(),
    rewardName: z.string().optional().nullable(),
    currency: z.string().optional().nullable(),
    totalBet: z.number().optional().nullable(),
    bonusCreationId: z.string().optional().nullable(),
    optimoveCampaignId: z.string().optional().nullable(),
    optimoveRequestId: z.string().optional().nullable(),
});
export type BonusDetailsFormType = z.TypeOf<typeof BonusDetailsFormZod>;


// #/components/schemas/Map_BonusType_BonusDetailsForm
export const Map_BonusType_BonusDetailsFormZod = z.record(z.string(), BonusDetailsFormZod);
export type Map_BonusType_BonusDetailsFormType = z.TypeOf<typeof Map_BonusType_BonusDetailsFormZod>;


// #/components/schemas/Map_Long_Map_BonusType_BonusDetailsForm
export const Map_Long_Map_BonusType_BonusDetailsFormZod = z.record(z.string(), Map_BonusType_BonusDetailsFormZod);
export type Map_Long_Map_BonusType_BonusDetailsFormType = z.TypeOf<typeof Map_Long_Map_BonusType_BonusDetailsFormZod>;


// #/components/schemas/Provider
export const ProviderZod = z.literal('pragmatic');
export type ProviderType = z.TypeOf<typeof ProviderZod>;


// #/components/schemas/BonusStatus
export const BonusStatusZod = z.union([z.literal('active'), z.literal('expired'), z.literal('canceled'), z.literal('claimed'), z.literal('rolled-back')]);
export type BonusStatusType = z.TypeOf<typeof BonusStatusZod>;


// #/components/schemas/BonusView
export const BonusViewZod = z.object({
    universe: z.string(),
    accountId: z.number(),
    bonusId: z.string(),
    bonusType: BonusTypeZod,
    campaignId: z.string().optional().nullable(),
    bonusCreationId: z.string().optional().nullable(),
    totalAmount: z.number().optional().nullable(),
    operatorTotalAmount: z.number().optional().nullable(),
    totalAmountTime: z.number().optional().nullable(),
    currentAmount: z.number().optional().nullable(),
    operatorCurrentAmount: z.number().optional().nullable(),
    currentAmountTime: z.number().optional().nullable(),
    createdAt: z.string().optional().nullable(),
    expiryAt: z.string(),
    startAt: z.string().optional().nullable(),
    bonusSource: BonusSourceZod,
    provider: z.union([ProviderZod, z.null()]).optional(),
    bonusPlatform: BettingPlatformZod,
    status: BonusStatusZod,
    usageConditions: z.array(CriteriaZod).optional(),
    rewardName: z.string().optional().nullable(),
    playthrough: z.number().optional().nullable(),
    playthroughEligibleGames: z.array(z.string()).optional().nullable(),
    totalBet: z.number().optional().nullable(),
});
export type BonusViewType = z.TypeOf<typeof BonusViewZod>;


// #/components/schemas/Map_BonusType_List_BonusView
export const Map_BonusType_List_BonusViewZod = z.record(z.string(), z.array(BonusViewZod));
export type Map_BonusType_List_BonusViewType = z.TypeOf<typeof Map_BonusType_List_BonusViewZod>;


// #/components/schemas/BonusBalanceView
export const BonusBalanceViewZod = z.object({
    universe: z.string(),
    availableAmount: z.number().optional().nullable(),
});
export type BonusBalanceViewType = z.TypeOf<typeof BonusBalanceViewZod>;


// #/components/schemas/Map_BonusType_BonusBalanceView
export const Map_BonusType_BonusBalanceViewZod = z.record(z.string(), BonusBalanceViewZod);
export type Map_BonusType_BonusBalanceViewType = z.TypeOf<typeof Map_BonusType_BonusBalanceViewZod>;


// #/components/schemas/CancelBonusForm
export const CancelBonusFormZod = z.object({
    bonusIds: z.array(z.string()).optional(),
});
export type CancelBonusFormType = z.TypeOf<typeof CancelBonusFormZod>;


// #/components/schemas/BonusWinningsWalletView
export const BonusWinningsWalletViewZod = z.object({
    bonusId: z.string(),
    balance: z.number(),
    currency: z.string().optional().nullable(),
    createdAt: z.string(),
    operatorBalance: z.number().optional().nullable(),
    wageringRequirements: z.number().optional().nullable(),
    playthrough: z.number().optional().nullable(),
    eligibleGames: z.array(z.string()).optional().nullable(),
    isBlocked: z.boolean(),
    status: BonusStatusZod,
    rewardName: z.string().optional().nullable(),
    campaignId: z.string().optional().nullable(),
});
export type BonusWinningsWalletViewType = z.TypeOf<typeof BonusWinningsWalletViewZod>;


// #/components/schemas/PlaythroughProgressView
export const PlaythroughProgressViewZod = z.object({
    totalRequiredPlaythrough: z.number(),
    currentProgress: z.number(),
    remainingPlaythrough: z.number(),
    bonusStatus: z.string(),
});
export type PlaythroughProgressViewType = z.TypeOf<typeof PlaythroughProgressViewZod>;


// #/components/schemas/OptInProgressView
export const OptInProgressViewZod = z.object({
    accountId: z.number(),
    createdAt: z.string(),
});
export type OptInProgressViewType = z.TypeOf<typeof OptInProgressViewZod>;


// #/components/schemas/BonusCreationStatus
export const BonusCreationStatusZod = z.union([z.literal('draft'), z.literal('published')]);
export type BonusCreationStatusType = z.TypeOf<typeof BonusCreationStatusZod>;


// #/components/schemas/BonusCreationView
export const BonusCreationViewZod = z.object({
    universe: z.string(),
    bonusCreationId: z.string(),
    name: z.string().optional().nullable(),
    terms: z.string().optional().nullable(),
    rewardType: z.union([BonusTypeZod, z.null()]).optional(),
    rewardName: z.string().optional().nullable(),
    rewardAmount: z.number().optional().nullable(),
    rewardExpiryAt: z.string().optional().nullable(),
    relativeExpiryDays: z.number().optional().nullable(),
    usageConditions: z.array(CriteriaZod).optional().nullable(),
    totalBet: z.number().optional().nullable(),
    playthrough: z.number().optional().nullable(),
    playthroughEligibleGames: z.array(z.string()).optional().nullable(),
    installmentCount: z.number().optional().nullable(),
    rewardInterval: z.number().optional().nullable(),
    scheduledReward: z.boolean().optional().nullable(),
    rewardDate: z.string().optional().nullable(),
    status: BonusCreationStatusZod,
});
export type BonusCreationViewType = z.TypeOf<typeof BonusCreationViewZod>;


// #/components/schemas/BonusCreationPatch
export const BonusCreationPatchZod = z.object({
    name: z.string().optional().nullable(),
    terms: z.string().optional().nullable(),
    rewardType: z.union([BonusTypeZod, z.null()]).optional(),
    rewardName: z.string().optional().nullable(),
    rewardAmount: z.number().optional().nullable(),
    rewardExpiryAt: z.string().optional().nullable(),
    relativeExpiryDays: z.number().optional().nullable(),
    usageConditions: z.array(CriteriaZod).optional().nullable(),
    totalBet: z.number().optional().nullable(),
    playthrough: z.number().optional().nullable(),
    playthroughEligibleGames: z.array(z.string()).optional().nullable(),
    installmentCount: z.number().optional().nullable(),
    rewardInterval: z.number().optional().nullable(),
    scheduledReward: z.boolean().optional().nullable(),
    rewardDate: z.string().optional().nullable(),
});
export type BonusCreationPatchType = z.TypeOf<typeof BonusCreationPatchZod>;

